<template>
  <v-container grid-list-md>
    <v-row md="12" class="filterWork d-flex flex-column ">
      <h1 style="font-size:40px ;color:#48445E">Works</h1>
      <v-row class="menu">
        <p @click="gradProject()">Graduate Project</p>
        <p @click="evt()">EveryThing</p>
        <p @click="html()">Html/Css/javascript</p>
        <p @click="angularf()">Angular</p>
        <p @click="vuef()">vue</p>
        <p @click="cmswp()">wordpress</p>
      </v-row>
    </v-row>
    <div class="graduted" v-show="grad">
      <v-row class="d-flex align-center  innerGrad">
        <v-col md="6">
          <img src="@/assets/1328.png" width="100%" />
        </v-col>
        <v-col md="5">
          <p>
            My Graduate Project is "MoodTracker". It is Applications to help
            patients with mental health. such as Depression, Stress disorder
            <br />
          </p>
          <p>
            The project has three levels user an application for mobile apps and
            web apps for administrators and doctor in an application developed
            by Angular Ionic Framework with the following features.
          </p>

          <span class="d-flex align-center justify-space-between">
            <img src="@/assets/check.png" class="check" />
            <p>
              it able to check mental health with the tests six types from
              Department of mental health
            </p>
          </span>
          <span class="d-flex align-center justify-space-between">
            <img src="@/assets/check.png" class="check" />
            <p>
              take some note daily life with the cute icons, support typing and
              voice recording
            </p>
          </span>
          <span class="d-flex align-center justify-space-evenly">
            <img src="@/assets/check.png" class="check" />
            <p>
              check your mood statics
            </p>
          </span>
        </v-col>
      </v-row>
      <br /><br />
      <v-row class="d-flex align-center  innerGrad">
        <v-col md="5">
          <p>
            web application for doctors in the system, they can search the
            mental health static test of users, in the part of administrators
            they will manage user account and news update
            <br />
            web application developed by angular 10 and firebase
          </p>
          <button
            class="btn_DownloadCV"
            @click="
              go(
                'https://drive.google.com/file/d/1TuvDcMmMHyCHtw-iD29TajEVjgvV2WHl/view?usp=sharing'
              )
            "
          >
            Download Document
          </button>
        </v-col>
        <v-col md="7">
          <div class="imgWeb">
            <img src="@/assets/doctor.png" width="100%" />
            <img src="@/assets/moodtrack1_1.png" width="100%" />
            <img src="@/assets/moodtrack2.png" width="100%" />
          </div>
        </v-col>
      </v-row>
    </div>
    <v-row class="workBoard" data-aos="fade-up">
      <v-col v-show="angular">
        <div class="workBox ang1" id="intern">
          <div class="txt">
            <div class="responde">responsive</div>
            <h1>Intership Project</h1>
            <h3>Toeic Bills</h3>
            <h5>using Mean stack (Angular MongoDB)</h5>
            <Toeic />
          </div>
        </div>
      </v-col>
      <v-col v-show="angular">
        <div class="workBox ang2" id="intern">
          <div class="txt">
            <div class="responde">responsive</div>
            <h1>Intership Project</h1>
            <h3>Angular Starter, Software in House</h3>
            <h5>using Mean stack (Angular MongoDB)</h5>
            <AngularSt />
          </div>
        </div>
      </v-col>
      <v-col md="4" v-show="angular">
        <div
          class="workBox covid"
          @click="go('https://covid19andstat.netlify.app/')"
        >
          <div class="txt">
            <div class="responde">responsive</div>
            <h2>Covid & Thai Static</h2>
            <h3>using angular 10 and api of department of disease control</h3>
          </div>
        </div>
      </v-col>
      <v-col v-show="angular">
        <div
          class="workBox grad"
          @click="go('https://moodtracker-20fb0.web.app/')"
        >
          <div class="txt">
            <div class="noneResponde">none-responsive</div>
            <h1>Graduated Project</h1>
            <h3>Mood Tracker (Web applications)</h3>
            <h3>(Angular/Firebase)</h3>
          </div>
        </div>
      </v-col>
      <v-col v-show="angular">
        <div
          class="workBox list"
          @click="go('https://todolistmeanstack.netlify.app/')"
        >
          <div class="txt">
            <div class="noneResponde">none-responsive</div>
            <h1>Todo List</h1>
            <h3>using mean stack</h3>
            <h3>(Angular/MongoDB)</h3>
          </div>
        </div>
      </v-col>
      <v-col class="workBox1" md="4" v-show="norm">
        <div
          class="workBox lorax"
          @click="go('https://loraxgrandpa.netlify.app')"
        >
          <div class="txt">
            <div class="noneResponde">none-responsive</div>
            <h1>Lorax Eye Rolling</h1>
            <h3>Html/css javascript</h3>
          </div>
          <!-- <img src="../assets/lorax.png" width="200px" /> -->
        </div>
      </v-col>
      <v-col v-show="norm">
        <div
          class="workBox cal"
          @click="go('https://calculatorastro.netlify.app/')"
        >
          <div class="txt">
            <div class="noneResponde">none-responsive</div>
            <h1>Calculator</h1>
            <h3>using html/css + vanila-tilt.js</h3>
          </div>
        </div>
      </v-col>
      <v-col v-show="norm">
        <div
          class="workBox kishi"
          id="kishiweb"
          @click="go('https://thaitemplejapanshrine.netlify.app/')"
        >
          <div class="txt">
            <div class="responde">responsive</div>
            <h1>WDC 2019</h1>
            <h3>Difference of Thai Temple and Japan Shrine</h3>
          </div>
        </div>
      </v-col>
      <v-col v-show="vue">
        <div
          class="workBox weather"
          @click="go('https://weatherforcasts.netlify.app/')"
        >
          <div class="txt">
            <div class="responde">responsive</div>
            <h1>Weather Forcast</h1>
            <h3>using vue.js and openweather api</h3>
          </div>
        </div>
      </v-col>
      <v-col v-show="angular">
        <div
          class="workBox tictactoe"
          @click="go('https://tictactoe-thechristmas.netlify.app')"
        >
          <div class="txt">
            <div class="responde">responsive</div>
            <h1>TicTacToe Game in Christmas team</h1>
            <h3>using Angular 10</h3>
          </div>
        </div>
      </v-col>
      <v-col v-show="norm">
        <div
          class="workBox itzy"
          @click="go('https://itzynotshy.netlify.app/')"
        >
          <div class="txt">
            <div class="noneResponde">none-responsive</div>
            <h1>Itzy NotShy</h1>
            <h3>using html/css</h3>
            <h3>Web fashion layout style</h3>
          </div>
        </div>
      </v-col>
      <v-col v-show="norm">
        <div
          class="workBox the8"
          @click="go('https://the8inthecube.netlify.app/')"
        >
          <div class="txt">
            <div class="noneResponde">none-responsive</div>
            <h1>The8 in The cube</h1>
            <h3>Web fashion layout style</h3>
            <h3>Listen Up the song! 🎵</h3>
          </div>
        </div>
      </v-col>
      <v-col v-show="norm">
        <div class="workBox thanos">
          <div class="txt">
            <div class="noneResponde">none-responsive</div>
            <h1>Thanos finger</h1>
            <h3>using html/css and canvas for fade object</h3>
          </div>
        </div>
      </v-col>
      <v-col v-show="wp">
        <div class="workBox iaid" @click="go('https://iaid.in.th/')">
          <div class="txt">
            <div class="responde">responsive</div>
            <h1>IAID</h1>
            <h5>Rmutt X Department Of Industrial Promotion</h5>
            <h3>using wordpress</h3>
          </div>
        </div>
      </v-col>
      <v-col v-show="wp">
        <div class="workBox rmutt" @click="go('http://www.eng.rmutt.ac.th/')">
          <div class="txt">
            <div class="responde">responsive</div>
            <h1>Rmutt website english version</h1>
            <h3>using wordpress</h3>
          </div>
        </div>
      </v-col>
    </v-row>
    <div class="worker" data-aos="fade-up">
      <v-row
        md="12"
        class="d-flex flex-column justify-center align-center  text-center work"
      >
        <img src="@/assets/maintenance3.png" class="techTopic" width="200" />
        <h1>My Tech Stack</h1>
        <p>Front-End Development</p>
      </v-row>
      <br /><br />
      <v-row class="logoTap">
        <v-col md="2">
          <img
            class="logo"
            src="@/assets/800px-HTML5_logo_and_wordmark.svg-min.png"
            width="70"
          />
        </v-col>
        <v-col md="2">
          <img
            class="logo"
            src="@/assets/CSS3_logo_and_wordmark.svg-min.png"
            width="40"
          />
        </v-col>
        <v-col md="2">
          <img
            class="logo"
            src="@/assets/0__rAD9NgK7l6KSlNc-min.png"
            width="100"
          />
        </v-col>
        <v-col md="2">
          <img
            class="logo"
            src="@/assets/1_mn6bOs7s6Qbao15PMNRyOA-min.png"
            width="70"
          />
        </v-col>
        <v-col md="2">
          <img
            class="logo"
            src="@/assets/480px-Unofficial_JavaScript_logo_2.svg-min.png"
            width="70"
          />
        </v-col>
        <v-col md="2">
          <img
            class="logo"
            src="@/assets/9353b600-0e54-11ea-9712-b79b66b93c00-min.png"
            width="100"
          />
        </v-col>
        <v-col md="2">
          <img class="logo" src="@/assets/angular-min.png" width="100" />
        </v-col>
        <v-col md="2">
          <img class="logo" src="@/assets/logo-min.png" width="70" />
        </v-col>
        <v-col md="2">
          <img
            class="logo"
            src="@/assets/1200px-Vue.js_Logo_2.svg-min.png"
            width="90"
          />
        </v-col>
        <v-col md="2">
          <img
            class="logo"
            src="@/assets/Ei5n6vBWoAEy5gp-min.png"
            width="100"
          />
        </v-col>
        <v-col md="2" align="start">
          <img
            class="logo"
            src="@/assets/MongoDB_Logo_FullColorBlack_RGB-4td3yuxzjs-min.png"
            width="100"
          />
        </v-col>
        <v-col md="2" align="start">
          <img class="logo" src="@/assets/logo-standard-min.png" width="100" />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import AngularSt from "../components/angularstarter";
import Toeic from "../components/toeic";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
// ..
AOS.init();
export default {
  data() {
    return {
      angular: true,
      vue: true,
      norm: true,
      wp: true,
      grad: false,
      colors: [
        "indigo",
        "warning",
        "pink darken-2",
        "red lighten-1",
        "deep-purple accent-4",
      ],
      slides: ["First", "Second", "Third", "Fourth", "Fifth"],
    };
  },
  components: { AngularSt, Toeic },
  methods: {
    go(url) {
      window.open(`${url}`);
    },
    cmswp() {
      this.angular = false;
      this.vue = false;
      this.norm = false;
      this.grad = false;
      this.wp = true;
    },
    angularf() {
      this.angular = true;
      this.vue = false;
      this.norm = false;
      this.grad = false;
      this.wp = false;
    },
    vuef() {
      this.angular = false;
      this.vue = true;
      this.norm = false;
      this.grad = false;
      this.wp = false;
    },
    evt() {
      this.angular = true;
      this.vue = true;
      this.norm = true;
      this.grad = false;
      this.wp = true;
    },
    html() {
      this.angular = false;
      this.vue = false;
      this.norm = true;
      this.grad = false;
      this.wp = false;
    },
    gradProject() {
      this.angular = false;
      this.vue = false;
      this.norm = false;
      this.grad = true;
      this.wp = false;
    },
  },
};
</script>

<style scoped>
.btn_DownloadCV {
  padding: 10px 20px 10px 20px;
  border-radius: 25px;
  color: white;
  background-color: #ff3555;
  outline: none;
}
.btn_DownloadCV:active {
  color: #ff3555;
  background: white;
  border: 1px solid #ff3555;
}
.btn_DownloadCV:hover {
  transform: scale(0.9);
  transition-duration: 0.5s;
}
@keyframes down {
  0%,
  100% {
    transform: translateY(-5px);
  }
  50% {
    transform: translateY(5px);
  }
}
.graduted {
  padding-top: 5em;
  color: #48445e;
}
.worker {
  height: auto !important;
  margin-top: 10em;
  color: #48445e;
}
.techTopic {
  animation: down 5s infinite;
}
.workBox {
  width: 100%;
  min-width: 250px;
  padding: 0 !important;
  max-height: 500px;
  height: 250px;
  background: white;
  border-radius: 20px;
  box-shadow: 0px 5px 20px rgba(92, 92, 92, 0.452);
  padding: 2em;
  z-index: 1;
}

.logo {
  opacity: 0.3;
  width: 60px !important;
  align-items: center;
  padding: 5px;
}
.logoTap {
  padding: 5em;
  margin-top: -5em;
}
.workBoard {
  margin-top: 2em;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.menu {
  display: flex;
  width: 60%;
  font-weight: 600;
  justify-content: space-evenly;
  padding: 5px;
  margin-top: 1.5em;
  color: #48445e;
}
.menu :hover {
  cursor: pointer;
  color: #fd3556;
  /* text-decoration-line: overline; */
}
.cal,
.itzy,
.the8,
.lorax,
.covid,
.thanos,
.weather,
.tictactoe,
.list,
.rmutt,
.kishi,
.grad,
.ang1,
.iaid {
  background-size: cover;
  background-position: center;
}
.rmutt {
  background-image: url("../assets/rmutt.png");
}

.ang2 {
  background-size: cover;
}
.lorax {
  background-image: url("../assets/lorax.png");
}
.kishi {
  background-image: url("../assets/kishi1.jpg");
}
.grad {
  background-image: url("../assets/moodtrack1.png");
}

.weather {
  background-image: url("../assets/weatherForcast.png");
}
.tictactoe {
  background-image: url("../assets/tictactor.png");
}
.ang1 {
  background-image: url("../assets/ang112.png");
}
.ang2 {
  background-image: url("../assets/ang2.png");
}

.thanos {
  background-image: url("../assets/thanos.png");
}

.itzy {
  background-image: url("../assets/itxy.png");
}
.cal {
  background-image: url("../assets/astro.png");
}
.the8 {
  background-image: url("../assets/the8.png");
}
.covid {
  background-image: url("../assets/covid.png");
}
.list {
  background-image: url("../assets/list.png");
}
.iaid {
  background-image: url("../assets/iaid.png");
}

.txt {
  opacity: 0;
  width: auto;
  height: 100%;
  color: white;
  border-radius: 20px;
  padding: 2em;
}
.txt:hover {
  cursor: pointer;
  background: #696be6cb;
  transition-duration: 1s;
  opacity: 1;
}
.workBox:hover {
}

.check {
  margin-right: 10px;
  margin-bottom: 20px;
}
.responde {
  background: #e9e9ff;
  text-align: center;
  border-radius: 20px;
  width: 100px;
  color: #696be6;
  font-size: 15px;
  font-size: 500;
}
.noneResponde {
  background: #e9e9ff;
  text-align: center;
  border-radius: 20px;
  width: 120px;
  color: #696be6;
  font-size: 15px;
  font-size: 500;
}
.imgWeb {
  transform-style: preserve-3d;
  transform: perspective(1000px) rotateY(-20deg) scale(1);
  margin-bottom: 10em;
}
.imgWeb img {
  position: absolute;
}
.imgWeb img:nth-child(3) {
  margin-top: 10px;
  margin-left: -3em;
  box-shadow: 5px 5px 15px rgba(128, 128, 128, 0.205);
}
.imgWeb img:nth-child(2) {
  margin-top: -20px;
  margin-left: -1.5em;
  box-shadow: 5px 5px 15px rgba(128, 128, 128, 0.205);
}
.imgWeb img:nth-child(1) {
  margin-top: -50px;
  margin-left: 0.5em;
  box-shadow: 5px 5px 15px rgba(128, 128, 128, 0.205);
}

@media screen and (max-width: 600px) {
  .menu {
    width: 100%;
  }
  .graduted .innerGrad {
    display: flex;
    flex-direction: column;
    padding: 0;
  }
  .logoTap {
    padding: 0;
    margin-top: 0;
  }
}
</style>
